import { Action, Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators';
import store from '@/store';

import { conduitApi } from '../api';
import { Label, LinkLabels } from '../models/label';
import { Response, Meta, ResponseSingle } from '../models/response';
import { ULID } from '../models/uLID';
import project from './project';

@Module({
	namespaced: true,
	name: 'label',
	store,
	dynamic: true
})
class LabelModule extends VuexModule {
	labelsLinked: Label[] = [];

	labelsUnlinked: Label[] = [];

	labels: Label[] = [];

	label: Label = {} as any;

	meta: Meta = {};

	@Mutation
	set(item: ResponseSingle<Label>): void {
		this.label = item.data;
	}

	@Mutation
	setAll(response: Response<Label>): void {
		this.labels = response.data;
		this.meta = response.meta;
	}

	@Mutation
	setAllLinked(response: Response<Label>): void {
		this.labelsLinked = response.data;
		this.meta = response.meta;
	}

	@Mutation
	setAllUnlinked(response: Response<Label>): void {
		this.labelsUnlinked = response.data;
		this.meta = response.meta;
	}

	@Action({ commit: 'setAll', rawError: true })
	async getAll(obj: { projectID: ULID; query: Object }): Promise<Response<Label>> {
		try {
			const response = await conduitApi.get(`/projects/${obj.projectID}/labels`, {
				params: obj.query
			});

			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'setAllLinked', rawError: true })
	async getAllQRLinkLinked(obj: { qrlinkID: ULID; query: any }): Promise<Response<Label>> {
		if (obj.query === undefined) {
			// eslint-disable-next-line no-param-reassign
			obj.query = {};
		}
		// eslint-disable-next-line no-param-reassign
		obj.query.type = 'linked';

		try {
			const response = await conduitApi.get(`/qrlinks/${obj.qrlinkID}/labels`, {
				params: obj.query
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'setAllUnlinked', rawError: true })
	async getAllQRLinkUnlinked(obj: { qrlinkID: ULID; query: any }): Promise<Response<Label>> {
		if (obj.query === undefined) {
			// eslint-disable-next-line no-param-reassign
			obj.query = {};
		}
		// eslint-disable-next-line no-param-reassign
		obj.query.type = 'unlinked';

		try {
			const response = await conduitApi.get(`/qrlinks/${obj.qrlinkID}/labels`, {
				params: obj.query
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'setAllLinked', rawError: true })
	async getAllQRCodeLinked(obj: { qrcodeID: ULID; query: any }): Promise<Response<Label>> {
		if (obj.query === undefined) {
			// eslint-disable-next-line no-param-reassign
			obj.query = {};
		}
		// eslint-disable-next-line no-param-reassign
		obj.query.type = 'linked';

		try {
			const response = await conduitApi.get(`/qrcodes/${obj.qrcodeID}/labels`, {
				params: obj.query
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'setAllUnlinked', rawError: true })
	async getAllQRCodeUnlinked(obj: { qrcodeID: ULID; query: any }): Promise<Response<Label>> {
		if (obj.query === undefined) {
			// eslint-disable-next-line no-param-reassign
			obj.query = {};
		}
		// eslint-disable-next-line no-param-reassign
		obj.query.type = 'unlinked';

		try {
			const response = await conduitApi.get(`/qrcodes/${obj.qrcodeID}/labels`, {
				params: obj.query
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'setAllLinked', rawError: true })
	async getAllAdvertisementLinked(obj: { advertisementID: ULID; query: any }): Promise<Response<Label>> {
		if (obj.query === undefined) {
			// eslint-disable-next-line no-param-reassign
			obj.query = {};
		}
		// eslint-disable-next-line no-param-reassign
		obj.query.type = 'linked';

		try {
			const response = await conduitApi.get(`/broadcasts/${obj.advertisementID}/labels`, {
				params: obj.query
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'setAllUnlinked', rawError: true })
	async getAllAdvertisementUnlinked(obj: { advertisementID: ULID; query: any }): Promise<Response<Label>> {
		if (obj.query === undefined) {
			// eslint-disable-next-line no-param-reassign
			obj.query = {};
		}
		// eslint-disable-next-line no-param-reassign
		obj.query.type = 'unlinked';

		try {
			const response = await conduitApi.get(`/broadcasts/${obj.advertisementID}/labels`, {
				params: obj.query
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'set', rawError: true })
	async get(id: string): Promise<ResponseSingle<Label>> {
		try {
			const response = await conduitApi.get(`/labels/${id}`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async add(params: Label): Promise<void> {
		try {
			await conduitApi.post(`/projects/${project.project.id}/labels`, JSON.stringify(params));
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async put(item: Label): Promise<void> {
		try {
			await conduitApi.put(`/labels/${item.id}`, JSON.stringify(item));
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async destroy(id: ULID): Promise<void> {
		try {
			await conduitApi.delete(`/labels/${id}`);
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async linkQRCode(obj: LinkLabels): Promise<void> {
		try {
			await conduitApi.post(`/qrcodes/${obj.itemID}/labels`, JSON.stringify(obj));
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async unlinkQRCode(obj: { qrcodeID: ULID; labelID: ULID }): Promise<void> {
		try {
			await conduitApi.delete(`/qrcodes/${obj.qrcodeID}/labels/${obj.labelID}`);
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async linkQRLink(obj: LinkLabels): Promise<void> {
		try {
			await conduitApi.post(`/qrlinks/${obj.itemID}/labels`, JSON.stringify(obj));
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async unlinkQRLink(obj: { qrlinkID: ULID; labelID: ULID }): Promise<void> {
		try {
			await conduitApi.delete(`/qrlinks/${obj.qrlinkID}/labels/${obj.labelID}`);
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async linkAdvertisement(obj: LinkLabels): Promise<void> {
		try {
			await conduitApi.post(`/broadcasts/${obj.itemID}/labels`, JSON.stringify(obj));
		} catch (error) {
			throw error;
		}
	}

	@Action({ rawError: true })
	async unlinkAdvertisement(obj: { advertisementID: ULID; labelID: ULID }): Promise<void> {
		try {
			await conduitApi.delete(`/broadcasts/${obj.advertisementID}/labels/${obj.labelID}`);
		} catch (error) {
			throw error;
		}
	}
}

export default getModule(LabelModule);
